class CollectionDescription extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isExpanded = false

    this.measureDescription()

    this.longHtml = this.els.long.element ? this.els.long.element.innerHTML : ''
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  handleClick (event) {
    const toggleEl = event.target.closest(
      '[data-collection-description-el="toggle"]',
    )
    if (!toggleEl) return

    this.toggleDescription()
  }

  measureDescription () {
    const longEl = this.els.long.element
    const shortEl = this.els.short.element

    if (!longEl || !shortEl) return
    if (!this.fullText || this.fullText.length < 20) return

    const style = getComputedStyle(longEl)

    const lineHeight = parseFloat(style.lineHeight)
    const maxLines = 2
    const maxHeight = lineHeight * maxLines

    const rect = longEl.getBoundingClientRect()
    const width = rect.width
    const actualHeight = rect.height

    if (actualHeight <= maxHeight) return

    const readMoreText = ` ${window.theme.strings.collectionDescriptionReadMore}`

    const tester = this.createTester(style, width)

    const fits = text => {
      tester.textContent = text + readMoreText
      return tester.getBoundingClientRect().height <= maxHeight
    }

    const words = this.fullText.split(' ')

    let low = 0
    let high = words.length
    let best = ''

    while (low <= high) {
      const mid = Math.floor((low + high) / 2)
      const candidate = words.slice(0, mid).join(' ')

      if (fits(candidate)) {
        best = candidate
        low = mid + 1
      } else {
        high = mid - 1
      }
    }

    document.body.removeChild(tester)

    shortEl.innerHTML = `
      ${best} <button data-collection-description-el="toggle" class="clc-ProductGrid_DescriptionToggle">${window.theme.strings.collectionDescriptionReadMore}</button>
    `

    shortEl.setAttribute('aria-hidden', 'false')
    longEl.setAttribute('aria-hidden', 'true')
  }

  createTester (style, width) {
    const tester = document.createElement('div')

    tester.style.position = 'absolute'
    tester.style.visibility = 'hidden'
    tester.style.width = `${width}px`
    tester.style.font = style.font
    tester.style.lineHeight = style.lineHeight
    tester.style.whiteSpace = 'normal'
    tester.style.wordBreak = style.wordBreak
    tester.style.letterSpacing = style.letterSpacing
    tester.style.padding = style.padding
    tester.style.boxSizing = style.boxSizing

    document.body.appendChild(tester)

    return tester
  }

  toggleDescription () {
    const longEl = this.els.long.element
    const shortEl = this.els.short.element

    this.isExpanded = !this.isExpanded

    if (this.isExpanded) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event: 'collection_read_more_click' })

      longEl.setAttribute('aria-hidden', 'false')
      shortEl.setAttribute('aria-hidden', 'true')

      longEl.innerHTML = `
      ${this.longHtml} <button data-collection-description-el="toggle" class="clc-ProductGrid_DescriptionToggle">${window.theme.strings.collectionDescriptionReadLess}</button>
    `
    } else {
      longEl.setAttribute('aria-hidden', 'true')
      shortEl.setAttribute('aria-hidden', 'false')

      this.measureDescription()
    }
  }

  get fullText () {
    return this.dataset.collectionDescriptionStrip
  }
}

if (!customElements.get('collection-description')) {
  customElements.define('collection-description', CollectionDescription)
}
